export default (containerNode, containedNode) => (
  containerNode &&
  containedNode &&
  (
    containerNode.contains(containedNode) ||
    containerNode === containedNode
  )
);
